const PSIRoutes: any = {
    path: 'psi',
    name: 'psi',
    component: () => import('@/views/Project/PSI/views/Index.vue'),
    meta: {
        permission: ['psi.view'],
        requireProject: false,
        title: 'project_menu.psi',
    },
    redirect: { name: 'psis' },
    children: [
        {
            path: 'c',
            meta: {
                title: 'project_menu.psi',
                breadcrumbs: false,
            },
            name: 'completions',
            component: () => import('@/views/Project/PSI/views/Completions.vue'),
        },
        {
            path: '/',
            meta: {
                title: 'project_menu.psi',
                breadcrumbs: false,
            },
            name: 'psis',
            component: () => import('@/views/Project/PSI/views/PSIs.vue'),
        },
    ],
}

export default PSIRoutes
